define("shared/components/shared/profile-categorization/rewards-steps/partnerships-opt-in", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <h2 class="tSC--card__title u--text--center u--m__0">
    {{@socialProfile.displayNickname}}
  </h2>
  
  <Shared::ProfileCategorization::SelectedTypes
    @businessModel={{@socialProfile.businessModel}}
    @category={{@socialProfile.category}}
    @handleResetSelection={{fn @clearSelectedCategory "summary"}}
    @industry={{@socialProfile.industry}}
    @prefix={{@prefix}}
  />
  
  <div class="tSC--result u--m__b u--p__0">
    <img class="o--media" src="/assets/images/img--selfCat--partnerships.png" />
  </div>
  
  <p class="u--text--bold u--text--md">{{t "influencers.opt_in.opt_in_cta"}}</p>
  <p>{{html-safe (t "influencers.opt_in.self_cat_body")}}</p>
  
  <Shared::Link
    @href="https://help.later.com/hc/articles/4415153789975"
    @text={{t "influencers.information.learn_more"}}
    class="u--m__b__md u--inline"
  />
  
  <Shared::Ui::Button
    @additional="block"
    @onClick={{@goToPartnerships}}
    @size="regular"
    @text={{t "influencers.opt_in.button"}}
    @variant="primary"
    {{track "clicked-join-partnerships-self-cat" "click"}}
  />
  
  <Shared::Ui::Button
    @additional="block"
    @class="u--text--hl u--text--hair"
    @onClick={{@exitCategorization}}
    @size="small"
    @text={{t "shared_phrases.not_now"}}
    @variant="none"
    {{track "clicked-not-now-partnerships-self-cat" "click"}}
  />
  */
  {
    "id": "k2NihIoI",
    "block": "[[[10,\"h2\"],[14,0,\"tSC--card__title u--text--center u--m__0\"],[12],[1,\"\\n  \"],[1,[30,1,[\"displayNickname\"]]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,0],null,[[\"@businessModel\",\"@category\",\"@handleResetSelection\",\"@industry\",\"@prefix\"],[[30,1,[\"businessModel\"]],[30,1,[\"category\"]],[28,[37,1],[[30,2],\"summary\"],null],[30,1,[\"industry\"]],[30,3]]],null],[1,\"\\n\\n\"],[10,0],[14,0,\"tSC--result u--m__b u--p__0\"],[12],[1,\"\\n  \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--selfCat--partnerships.png\"],[12],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,2],[14,0,\"u--text--bold u--text--md\"],[12],[1,[28,[35,2],[\"influencers.opt_in.opt_in_cta\"],null]],[13],[1,\"\\n\"],[10,2],[12],[1,[28,[35,3],[[28,[37,2],[\"influencers.opt_in.self_cat_body\"],null]],null]],[13],[1,\"\\n\\n\"],[8,[39,4],[[24,0,\"u--m__b__md u--inline\"]],[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/4415153789975\",[28,[37,2],[\"influencers.information.learn_more\"],null]]],null],[1,\"\\n\\n\"],[8,[39,5],[[4,[38,6],[\"clicked-join-partnerships-self-cat\",\"click\"],null]],[[\"@additional\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[\"block\",[30,4],\"regular\",[28,[37,2],[\"influencers.opt_in.button\"],null],\"primary\"]],null],[1,\"\\n\\n\"],[8,[39,5],[[4,[38,6],[\"clicked-not-now-partnerships-self-cat\",\"click\"],null]],[[\"@additional\",\"@class\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[\"block\",\"u--text--hl u--text--hair\",[30,5],\"small\",[28,[37,2],[\"shared_phrases.not_now\"],null],\"none\"]],null]],[\"@socialProfile\",\"@clearSelectedCategory\",\"@prefix\",\"@goToPartnerships\",\"@exitCategorization\"],false,[\"shared/profile-categorization/selected-types\",\"fn\",\"t\",\"html-safe\",\"shared/link\",\"shared/ui/button\",\"track\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/partnerships-opt-in.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});